import { IoMdSettings } from "react-icons/io";
import { BsShop } from "react-icons/bs";
import { RiShoppingCartLine } from "react-icons/ri";
import { IoReceiptOutline } from "react-icons/io5";
import { FaMoneyBillTransfer, FaCartFlatbed } from "react-icons/fa6";
import { BsPercent } from "react-icons/bs";
import { FiUpload } from "react-icons/fi";
import { RxActivityLog } from "react-icons/rx";
import ROUTES from "./routes";

const SettingLists = [
  {
    name: "General",
    link: ROUTES.generalSettings.path,
    icon: <IoMdSettings />,
  },
  // {
  //   name: "Business Information",
  //   link: "#",
  //   icon: <BsShop />,
  // },
  // {
  //   name: "Online Catalog",
  //   link: "#",
  //   icon: <RiShoppingCartLine />,
  // },
  // {
  //   name: "My Receipt",
  //   link: "#",
  //   icon: <IoReceiptOutline />,
  // },
  // {
  //   name: "Payment Options",
  //   link: ROUTES.paymentSettings.path,
  //   icon: <FaMoneyBillTransfer />,
  // },
  {
    name: "Orders and Sales",
    link: ROUTES.ordersSalesSettings.path,
    icon: <BsPercent />,
  },
  {
    name: "Delivery Rates",
    link: ROUTES.deliverySettings.path,
    icon: <FaCartFlatbed />,
  },
  {
    name: "Account Activities",
    link: ROUTES.activitiesSettings.path,
    icon: <RxActivityLog />,
  },
  // {
  //   name: "Export Reports",
  //   link: "#",
  //   icon: <FiUpload />,
  // },
];

export default SettingLists;
